import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import {DefaultService} from './abstract/default.service';
import {BehaviorSubject} from "rxjs";

@Injectable()
export class SharedRoutesService extends DefaultService {

    onItemUpdate: BehaviorSubject<any>;

    constructor(public override http: HttpClient) {
        super(http);
        this.setResourceLink('navigation/rights');
        this.onItemUpdate = new BehaviorSubject([]);
    }

}
